import {
  ComponentType,
  ForwardedRef,
  forwardRef,
} from 'react';

export type GenericForward<T = unknown> = ComponentType<T>;

export function forwardRefWrapper<CPROP>(Component: GenericForward<CPROP>) {
  const component = (props: CPROP, ref: ForwardedRef<HTMLElement>) => (
    <Component
      {...props}
      forwardedRef={ref}
    />
  );

  component.displayName = Component.displayName || Component.name;

  return forwardRef(component);
}
